export default __webpack_public_path__ + "static/media/derpina-156.b8f62476.png";